import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  activeChatHeadData: {
    title: '',
  },
};
export const sliceKey = 'activeChatHead';

export const activeChatHeadSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    activeChatHead: (state, { payload }) => {
      try {
        state.activeChatHeadData = payload.activeChatHeadData;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { activeChatHead } = activeChatHeadSlice.actions;

export default activeChatHeadSlice.reducer;
